module.exports = __webpack_public_path__ + "img/bg2.596cac4f.png";